// AUTH APIs

export const LOGN_API = "/auth/login";
export const REGISTER_STEP1_API = "/auth/register/1";
export const REGISTER_STEP2_API = "/auth/verifyOTP";
export const REGISTER_STEP3_API = "/auth/register/3";
export const SIGNUP_API = "/auth/register/2";
export const CHANGEPASSWORD_API = "/auth/change-password";
export const FORGOTPASSWORD_API = "/auth/forgot-password";
export const RESETPASSWORD_API = "/auth/reset-password";

// ADDRESS APIs

export const PROVINCE_API = "/provinces";
export const CITY_API = "/cities";
export const AREA_API = "/areas";

export const ADDRESS_SAVE_API = "/address";
export const ADDRESS_GET_API = "/address";
export const ADDRESS_UPDATE_API = "/address";
export const ADDRESS_SELECTED_API = "/default";

// USER PROFILE APIs

export const GET_USER_PROFILE_API = "/user/profile";
export const UPDATE_USER_PROFILE_API = "/user/profile";

// HOME PAGE APIs

export const GET_HOME_API = "/public/home";
export const GET_MENU_API = "/public/home/menu";
export const GET_HOME_SEARCH_API = "/public/category/search";

// WISHLIST APIs

export const GET_WISHLIST_API = "/user/wishlist";
export const DELETE_WISHLIST_API = "/user/wishlist/remove";
export const POST_ADD_WISHLIST_API = "/user/wishlist/add";

// CART APIs
export const ADD_CART_ITEM_API = "/cart/add";
export const GET_CART_API = "/cart";
export const POST_CART_DETAILS_API = "/details";
export const CART_REMOVE_ITEM_API = "/remove-item";

// CART WISHLIST COUNT API
export const CART_WISHLIST_COUNT_ITEM_API = "/cart-wishlist/count";

// DELIVERY_API
export const DELIVERY_OPTIONS_API = "/delivery-options";
export const SELECT_DELIVERY_OPTION_API = "/order/checkout/";

// PRODUCT_API
export const GET_PRODUCT_API = "/public/product";

// SHOP_API
export const SHOP_GET_API = "/public/products/inventory";

// PAYMENT API
export const PAYMENT_GET_API = "/payment/options";
export const PAYMENT_POST_ORDER_API = "/order/payment/cash-on-delivery";

// PLACE ORDER
export const PLACE_ORDER_POST_API = "/order/place";

//
// ORDERS HISTORY
export const ORDERS_GET_API = "/order/status/PAYMENT_PENDING?page=0&size=/10";
